import api from './api';
import authHeader from './auth-header';

class UserService {
    getCurrentUser() {
        return api.get('/test/user', { headers: authHeader() });
    }

    getPublicContent() {
        return api.get('/test/users/status', { headers: authHeader() });
    }

    updateCompany(company) {
        return api.put('/user/company', { company }, { headers: authHeader() });
    }
}

const userService = new UserService();
export default userService;




